// src/pages/SobreNosotros.jsx
import React from "react";

const SobreNosotros = () => {
  return (
    <div className="container py-4">
      <h1 className="fw-bold mb-3">Sobre QRBenefits</h1>
      <p className="text-secondary">
        QRBenefits nace con el objetivo de conectar a comercios locales con personas
        que buscan descuentos reales y beneficios simples de usar.
      </p>
      <p className="text-secondary">
        Nuestra misión es hacer más accesibles los beneficios y ayudar a los negocios
        a fidelizar clientes mediante tecnología fácil, rápida y sin complicaciones.
      </p>
    </div>
  );
};

export default SobreNosotros;
